export default {
    routeBusinessStockDeliveryResultView: {
        Basic: '出库基本信息',
        Delivery: '出库结果单号',
        Outbound: '出库逻辑仓编码',
        Name: '出库逻辑仓名称',
        Logistics: '物流',
        business: '物流业务',
        Consignee: '收货人',
        Contact: '联系电话',
        Shipping: '收货地址',
        Creation: '创建时间',
        Created: '创建人',
        Associated: '关联单据',
        Doc: '物流单号',
        notice: '出库通知单号',
        WMS: 'WMS单号',
        Product: '商品明细',
        // code: '商品编码',
        SKU: 'SKU名称',
        SKUcode: 'SKU编码',
        Quantity: '已发货数量',
        // Productname: '商品名称',
        Shipped: '已发货数量：',
    }
};
